import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=fd90dc0c&scoped=true"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"
import style0 from "./AppSidebar.vue?vue&type=style&index=0&id=fd90dc0c&prod&lang=scss&scoped=true"
import style1 from "./AppSidebar.vue?vue&type=style&index=1&id=fd90dc0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd90dc0c",
  null
  
)

export default component.exports